export enum ValidationResultType {
    Success = 3,
    Warning = 2,
    Error = 1,
}

export default ValidationResultType;
